import { render, staticRenderFns } from "./NavbarComponent.vue?vue&type=template&id=126b7475&scoped=true"
import script from "./NavbarComponent.js?vue&type=script&lang=js&external"
export * from "./NavbarComponent.js?vue&type=script&lang=js&external"
import style0 from "./NavbarComponent.vue?vue&type=style&index=0&id=126b7475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126b7475",
  null
  
)

export default component.exports